export class FacebookLoginModel {
  public accessToken: string;
  public signupReason?: string;
}
